import { render, staticRenderFns } from "./MyRecords.vue?vue&type=template&id=f25bd6ba&scoped=true&"
import script from "./MyRecords.vue?vue&type=script&lang=js&"
export * from "./MyRecords.vue?vue&type=script&lang=js&"
import style0 from "./MyRecords.vue?vue&type=style&index=0&id=f25bd6ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f25bd6ba",
  null
  
)

export default component.exports